import React, { Component } from "react";
import PropTypes from "prop-types";
import jwt_decode from "jwt-decode";
import InputForm from "../../../../../../shared/atoms/InputForm";
import SelectForm from "../../../../../../shared/atoms/SelectForm";
import AutoSuggestForm from "../../../../../../shared/atoms/AutoSuggestForm";
import { getUserToken } from "../../../../../shared/utils";
import {
	cpfMask,
	cnpjMask,
	patternOnlyNumbers
} from "../../../../../../shared/create-offer/utils/masks";
import { Heading } from "@maxmilhas/hangar-components-atomic/public";
import AcceptanceTerms from "../../../../../../shared/create-offer/AcceptanceTerms/AcceptanceTerms";


class EditBankDetails extends Component {
	constructor() {
		super();
		this.state = {
			cpfcnpj: "",
			bankId: "",
			agency: "",
			account: "",
			errors: {
				cpfcnpj: false,
				bankId: false,
				agency: false,
				account: false
			}
		};

		this.onChange = this.onChange.bind(this);
		this.checkAllFilled = this.checkAllFilled.bind(this);
	}

	checkAllFilled() {
		const { checkData } = this.props;
		const { cpfcnpj, bankId, agency, account, errors } = this.state;

		let fieldsIsCompleted =
			!!cpfcnpj &&
			!!bankId &&
			!!agency &&
			!!account &&
			!errors.cpfcnpj &&
			!errors.bankId &&
			!errors.agency &&
			!errors.account;

		checkData("completedBoxDataBankDetails", fieldsIsCompleted);
	}

	onChange(event) {
		const { name, value } = event.target;
		const { setData } = this.props;
		const { errors, bankId } = this.state;

		switch (name) {
			case "cpfcnpj":
				this.setState({ errors: { ...errors, cpfcnpj: !value.length } });
				break;
			case "bankId":
				this.setState({
					[name]: value,
					agency: "",
					account: "",
					errors: {
						...errors,
						bankId: !value,
						agency: value != 45 && this.state.agency.length > 4
					}
				});
				setData({ [name]: value });
				break;
			case "agency":
				let agency = value.match(patternOnlyNumbers)
					? value
							.match(patternOnlyNumbers)
							.join("")
							.toString()
					: "";
				this.setState({
					[name]: bankId == 45 ? agency.replace(/(\d)(\d{1}$)/g, "$1-$2") : agency,
					errors: {
						...errors,
						agency: !agency.length || agency.length < 3 || (bankId != 45 && agency.length > 4)
					}
				});
				setData({ [name]: bankId == 45 ? agency.replace(/(\d)(\d{1}$)/g, "$1-$2") : agency });
				break;
			case "account":
				let account = value.match(patternOnlyNumbers)
					? value
							.match(patternOnlyNumbers)
							.join("")
							.toString()
					: "";
				this.setState({
					[name]: account.replace(/(\d)(\d{1}$)/g, "$1-$2"),
					errors: { ...errors, account: !account.length }
				});
				setData({ [name]: account.replace(/(\d)(\d{1}$)/g, "$1-$2") });
				break;
		}

		setTimeout(() => this.checkAllFilled(), 200);
	}

	componentWillMount() {
		const { bankData } = this.props;
		const { setData } = this.props;

		let token = getUserToken();
		let payload = jwt_decode(token);

		let cpfcnpj = bankData.cpfcnpj
			? bankData.cpfcnpj
			: payload.ssn
					.match(patternOnlyNumbers)
					.join("")
					.toString();
		let bankId = bankData.bankId ? bankData.bankId : "";
		let agency = bankData.agency ? bankData.agency : "";
		let account = bankData.account ? bankData.account : "";

		this.setState({
			cpfcnpj,
			bankId,
			agency,
			account
		});
		setData({ cpfcnpj: cpfcnpj });

		setTimeout(() => this.checkAllFilled(), 200);
	}

	render() {
		const { className, options, setInputInFocus, acceptanceTerms, setAcceptanceTerms } = this.props;
		const { cpfcnpj, bankId, agency, account, errors } = this.state;

		const ruleMaskInputUser = cpfcnpj.length <= 14 ? cpfMask : cnpjMask;

		// let optionsBank = [{ label: "Selecione", value: "" }];
		let optionsBank = [];

		options.map(item => {
			optionsBank.push({
				label: item.name,
				value: item.idBank
			});
		});

		return (
			<div className={`edit-fidelity-program-and-bank-details`}>
				<Heading tag="h6">Dados bancários</Heading>
				<div className="row">
					<div className="col-xs-16">
						<InputForm
							ref={el => (this.inputUser = el)}
							name="cpfcnpj"
							id="cpfcnpj"
							value={cpfcnpj}
							onChange={this.onChange}
							onFocus={() => setInputInFocus("cpfcnpj")}
							onBlur={() => setInputInFocus("")}
							disabled={cpfcnpj}
							placeholder=""
							label="CPF do titular"
							mask={ruleMaskInputUser}
							hasError={errors.cpfcnpj}
							data-action="register-credit-card-cpfcnpj"
						/>
					</div>
					<div className="col-xs-16">
						<AutoSuggestForm
							name="bankId"
							options={optionsBank}
							defaultValue={bankId}
							onChange={this.onChange}
							onFocus={() => setInputInFocus("bankId")}
							label="Banco"
							suggestionKeyToRender="label"
							suggestionKeyValueToUse="label"
							hasError={errors.bankId}
							data-action="register-bank-details-bank-select"
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-16">
						<InputForm
							ref={el => (this.inputAgency = el)}
							name="agency"
							id="agency"
							type="tel"
							value={bankId == 45 ? agency.replace(/(\d)(\d{1}$)/g, "$1-$2") : agency}
							onChange={this.onChange}
							onFocus={() => setInputInFocus("agency")}
							onBlur={() => setInputInFocus("")}
							placeholder=""
							label="Agência"
							maxLength={bankId == 45 ? 6 : 4}
							hasError={errors.agency}
							data-action="register-bank-details-agency"
						/>
					</div>
					<div className="col-xs-16">
						<InputForm
							ref={el => (this.inputAccount = el)}
							name="account"
							id="account"
							type="tel"
							value={account.replace(/(\d)(\d{1}$)/g, "$1-$2")}
							onChange={this.onChange}
							onFocus={() => setInputInFocus("account")}
							onBlur={() => setInputInFocus("")}
							placeholder=""
							label="Conta corrente"
							maxLength="20"
							hasError={errors.account}
							data-action="register-bank-details-account"
						/>
					</div>
					<div className="col-xs-16">
						<AcceptanceTerms 
							acceptanceTerms={acceptanceTerms} 
							setAcceptanceTerms={setAcceptanceTerms}
						/>
					</div>
				</div>
			</div>
		);
	}
}

EditBankDetails.propTypes = {
	bankData: PropTypes.object.isRequired,
	checkData: PropTypes.func,
	className: PropTypes.string,
	options: PropTypes.array.isRequired,
	setData: PropTypes.func,
	setInputInFocus: PropTypes.func
};

export default EditBankDetails;
